import { useEffect, useState } from 'react';
import { useAppSelector } from '@/store/hooks';
import { selectProjectChannel } from '@/store/slices/project/selectors';
import { ProjectRegistrantCounts } from '@/types/registration.types';
import { useProjectUuidParam } from '@/utils/use-project-uuid-param';

// this hook is dropped in multiple places - use a single loader to prevent thrashing the database
import countLoader from './loader-registrant-counts';

export const useLoadEventRegistrantCounts = () => {
  const projectUuid = useProjectUuidParam();
  const channel = useAppSelector(selectProjectChannel);

  const [counts, setCounts] = useState<ProjectRegistrantCounts | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!channel || !projectUuid) {
      setCounts(null);
      setLoading(false);
      return;
    }

    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);

        const response = await countLoader.get({
          channel,
          projectUuid,
        });

        setCounts(response);
        setLoading(false);
      } catch (err: unknown) {
        if (err instanceof Error && err.name === 'AbortError') {
          return;
        }
        console.error('Error fetching event registrant counts:', err);
        setError(err instanceof Error ? err : new Error('Failed to fetch event registrant counts'));
        setLoading(false);
      }
    };

    fetchData();
  }, [channel, projectUuid]);

  return { counts, loading, error };
};
